import { render } from "./ResourcePanel.vue?vue&type=template&id=77f7d7d9&scoped=true"
import script from "./ResourcePanel.vue?vue&type=script&lang=js"
export * from "./ResourcePanel.vue?vue&type=script&lang=js"

import "./ResourcePanel.vue?vue&type=style&index=0&id=77f7d7d9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f7d7d9"]])

export default __exports__